
import { defineComponent } from "vue";
import Button from "../Generics/Button.vue";
import ButtonRequest from "../Generics/ButtonRequest.vue";
import MenuHamburguer from "./MenuHamburguer.vue";

export default defineComponent({
  name: "Navbar",
  components: {
    Button,
    ButtonRequest,
    MenuHamburguer,
  },
  data() {
    return {
      icon: require("../../assets/icons/navbar/Hamb.png") as String,
      hamb: false as boolean,
    };
  },
  emits: ["menu"],
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    changeIcon() {
      if (this.icon == require("../../assets/icons/navbar/Hamb.png")) {
        this.icon = require("../../assets/icons/navbar/Close.png");
        this.hamb = !this.hamb;
      } else {
        this.icon = require("../../assets/icons/navbar/Hamb.png");
        this.hamb = !this.hamb;
      }
      this.$emit("menu");
    },
    handleResize() {
      const screenWidth = window.innerWidth;
      if (screenWidth > 600) {
        this.hamb = false;
        this.icon = require("../../assets/icons/navbar/Hamb.png");
      }
    },
  },
});
